import { render, staticRenderFns } from "./InputFileLink.vue?vue&type=template&id=513a0860"
import script from "./InputFileLink.vue?vue&type=script&lang=js"
export * from "./InputFileLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports